import { isPlatformBrowser } from '@angular/common';
import { HttpEventType } from '@angular/common/http';
import { Component, Inject, Optional, PLATFORM_ID } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import readXlsxFile from 'read-excel-file';
import { firstValueFrom } from 'rxjs';
import { ModalObjectType } from 'src/app/interfaces/modal-object-types.interface';
import { MechanicImportModel } from 'src/app/models/imports/mechanic-import-model';
import { LoadPreInvoicingModel } from 'src/app/models/invoicing/load-preinvoicing.models';
import { PreInvoicingAlertModel } from 'src/app/models/invoicing/pre-invoicing-alert.models';
import { MechanicService } from 'src/app/services/archive/mechanic.service';
import { ToastHandlerService } from 'src/app/services/toast/toast-handler.service';

@Component({
  selector: 'app-import-mechanic',
  templateUrl: './import-mechanic.component.html',
  styleUrls: ['./import-mechanic.component.scss'],
  standalone: false
})
export class ImportMechanicComponent {

  mechanicAlerts: Array<PreInvoicingAlertModel> = new Array<PreInvoicingAlertModel>;
  errorMechanic: number = 0;
  eventFile: any;
  loadPreInvoicingModel: LoadPreInvoicingModel = new LoadPreInvoicingModel();
  nameFile: string = '';
  mechanicImport: boolean = false;
  visibleTxt: boolean = false;

  constructor(
    private mechanicService: MechanicService,
    public config: DynamicDialogConfig,
    private toastHandlerService: ToastHandlerService,
    @Optional() private ref: DynamicDialogRef,
    @Inject(PLATFORM_ID) private platformId: object) { }

  attachFileImport() {
    //validación para ejecutar el código cuando la platafoma de uso sea un navegador
    if (isPlatformBrowser(this.platformId)) {
      document.getElementById('fileImport')?.click();
    }
  }

  clearInputFile() {
    this.nameFile = 'Ningún archivo seleccionado.';
    if (this.eventFile) {
      if (isPlatformBrowser(this.platformId)) {
        this.eventFile.target.value = '';
      }
    }
  }

  close() {
    const data: ModalObjectType = {};
    if (this.mechanicImport) {
      data.params = { reload: true };
      this.ref.close(data);
    } else {
      data.params = { reload: false };
      this.ref.close(data);
    }
  }

  getNameFile(file: any) {
    this.eventFile = file;
    const files = this.eventFile.target.files;
    if (files.length != 0) {
      for (let i = 0; i < files.length; i++) {
        this.nameFile = files[i].name;
      }
    } else {
      this.nameFile = 'Ningún archivo seleccionado.';
    }
  }

  downloadGuideImport() {
    this.mechanicService.downloadGuideImport().subscribe(data => {
      switch (data.type) {
        case HttpEventType.Response: {
          const downloadedFile = new Blob([data.body!], { type: data.body!.type });
          const a = document.createElement('a');
          a.setAttribute('style', 'display:none;');
          document.body.appendChild(a);
          a.download = "GuiaMecanicos.docx";
          a.href = URL.createObjectURL(downloadedFile);
          a.target = '_blank';
          a.click();
          document.body.removeChild(a);
          break;
        }
      }
    });
  }

  downloadErrorsTxt() {
    if (!this.mechanicAlerts || this.mechanicAlerts.length === 0) {
      this.toastHandlerService.showToast(
        'error',
        'No hay alertas para exportar'
      );
      return;
    }

    this.mechanicService.exportImportErrors(this.mechanicAlerts).subscribe({
      next: (blob: Blob) => {
        const file = new Blob([blob], { type: 'text/plain' });
        const url = window.URL.createObjectURL(file);
        const today = new Date();
        const formatDate = today.toISOString().split('T')[0];

        const a = document.createElement('a');
        a.href = url;
        a.download = `ErroresImportacionMecanicos_${formatDate}.txt`;
        a.click();

        window.URL.revokeObjectURL(url);
      },
      error: () => {
        this.toastHandlerService.showToast(
          'error',
          'Error al exportar el archivo'
        );
      }
    });
  }

  importMechanics() {
    this.mechanicAlerts = [];
    this.errorMechanic = 0;
    this.visibleTxt = false;
    //validación para ejecutar el código cuando la platafoma de uso sea un navegador
    if (!isPlatformBrowser(this.platformId)) return;
    let isOk: boolean = true;
    const input = document.getElementById("fileImport") as any;
    const rowsImports = new Array<MechanicImportModel>();
    let row: MechanicImportModel;
    let counter: number = 1, branchCode: number, typeDocumentId: number, documents: string, digitVerification: number, name: string,
      address: string, phone: string, alterPhone: string | null, contact: string | null, active: boolean, swExternal: boolean;

    if (!input.files[0]) {
      this.toastHandlerService.showToast(
        'error',
        'No ha seleccionado ningún archivo.'
      );
      return;
    }

    readXlsxFile(input.files[0]).then(async (rows) => {
      if (rows.length <= 1) {
        this.toastHandlerService.showToast(
          'error',
          'El archivo ingresado no tiene registros para importar.'
        );
        return;
      }
      rows.splice(0, 1);
      rows.forEach(element => {
        counter = counter + 1;
        let rowHasError = false;

        //A. Código Sucursal:
        branchCode = parseFloat(element[0] as string);
        if (isNaN(branchCode)) {
          const alert = new PreInvoicingAlertModel();
          alert.alertType = 1;
          alert.message = `Fila ${counter}, Columna A. El código de la sucursal no es válido.`;
          this.mechanicAlerts.push(alert);
          rowHasError = true;
        }

        //B. Tipo Documento:
        const valueTypeDocumentId = element[1];
        if (valueTypeDocumentId == null || valueTypeDocumentId === "") {
          const alert = new PreInvoicingAlertModel();
          alert.alertType = 1;
          alert.message = `Fila ${counter}, Columna B. El código del tipo de documento no es válido.`;
          this.mechanicAlerts.push(alert);
          rowHasError = true;
        }
        typeDocumentId = Number(valueTypeDocumentId);
        if (isNaN(typeDocumentId)) {
          const alert = new PreInvoicingAlertModel();
          alert.alertType = 1;
          alert.message = `Fila ${counter}, Columna B. El código del tipo de documento no es válido.`;
          this.mechanicAlerts.push(alert);
          rowHasError = true;
        }

        //C. Documento:
        documents = element[2] as string;
        if (documents == null) {
          const alert = new PreInvoicingAlertModel();
          alert.alertType = 1;
          alert.message = `Fila ${counter}, Columna C. El número de documento no es válido.`;
          this.mechanicAlerts.push(alert);
          rowHasError = true;
        } else if (documents.length > 15) {
          const alert = new PreInvoicingAlertModel();
          alert.alertType = 1;
          alert.message = `Fila ${counter}, Columna C. El número de documento supera el tamaño máximo de caracteres (15).`;
          this.mechanicAlerts.push(alert);
          rowHasError = true;
        }

        //D. Dígito de Verificación
        const valueDigitVerification = element[3];
        if (valueDigitVerification == null || valueDigitVerification === "") {
          const alert = new PreInvoicingAlertModel();
          alert.alertType = 1;
          alert.message = `Fila ${counter}, Columna D. El dígito de verificación no es válido.`;
          this.mechanicAlerts.push(alert);
          rowHasError = true;
        }
        digitVerification = Number(valueDigitVerification);
        if (isNaN(digitVerification)) {
          const alert = new PreInvoicingAlertModel();
          alert.alertType = 1;
          alert.message = `Fila ${counter}, Columna D. El dígito de verificación no es válido.`;
          this.mechanicAlerts.push(alert);
          rowHasError = true;
        }

        //E. Nombre Mecánico:
        name = element[4] as string;
        if (name == null) {
          const alert = new PreInvoicingAlertModel();
          alert.alertType = 1;
          alert.message = `Fila ${counter}, Columna E. El nombre del mecánico no es válido.`;
          this.mechanicAlerts.push(alert);
          rowHasError = true;
        } else if (name.length > 100) {
          const alert = new PreInvoicingAlertModel();
          alert.alertType = 1;
          alert.message = `Fila ${counter}, Columna E. El nombre del mecánico supera el tamaño máximo de caracteres (100).`;
          this.mechanicAlerts.push(alert);
          rowHasError = true;
        }

        //F. Dirección:
        address = element[5] as string;
        if (address != null && address.length > 70) {
          const alert = new PreInvoicingAlertModel();
          alert.alertType = 1;
          alert.message = `Fila ${counter}, Columna F. La dirección supera el tamaño máximo de caracteres (70).`;
          this.mechanicAlerts.push(alert);
          rowHasError = true;
        }

        //G. Número Teléfono:
        phone = element[6] as string;
        if (phone == null) {
          const alert = new PreInvoicingAlertModel();
          alert.alertType = 1;
          alert.message = `Fila ${counter}, Columna G. El número de teléfono no es válido.`;
          this.mechanicAlerts.push(alert);
          rowHasError = true;
        } else if (phone.length > 15) {
          const alert = new PreInvoicingAlertModel();
          alert.alertType = 1;
          alert.message = `Fila ${counter}, Columna G. El número de teléfono supera el tamaño máximo de caracteres (15).`;
          this.mechanicAlerts.push(alert);
          rowHasError = true;
        }

        //H. Segundo Número Telefono:
        alterPhone = element[7] as string;
        if (alterPhone != null) {
          if (alterPhone.length > 15) {
            const alert = new PreInvoicingAlertModel();
            alert.alertType = 1;
            alert.message = `Fila ${counter}, Columna H. El número de teléfono alterno supera el tamaño máximo de caracteres (15).`;
            this.mechanicAlerts.push(alert);
            rowHasError = true;
          }
        }

        //I. Contacto:
        contact = element[8] as string;
        if (contact != null) {
          if (contact.length > 100) {
            const alert = new PreInvoicingAlertModel();
            alert.alertType = 1;
            alert.message = `Fila ${counter}, Columna I. El campo contacto supera el tamaño máximo de caracteres (100).`;
            this.mechanicAlerts.push(alert);
            rowHasError = true;
          }
        }

        // J. Activo:
        if (element[9] as string != "S" && element[9] as string != "N") {
          const alert = new PreInvoicingAlertModel();
          alert.alertType = 1;
          alert.message = `Fila ${counter}. El campo activo debe tener valores como: S / N.`;
          this.mechanicAlerts.push(alert);
          rowHasError = true;
        }
        active = element[9] as string === "S" ? true : false;

        // K. Sw Externo:
        if (element[10] as string != "S" && element[10] as string != "N") {
          const alert = new PreInvoicingAlertModel();
          alert.alertType = 1;
          alert.message = `Fila ${counter}. El campo sw externo debe tener valores como: S / N.`;
          this.mechanicAlerts.push(alert);
          rowHasError = true;
        }
        swExternal = element[10] as string === "S" ? true : false;

        if (!rowHasError) {
          row = new MechanicImportModel(counter, branchCode, typeDocumentId, documents, digitVerification, name, address, phone, alterPhone,
            contact, active, swExternal);
          rowsImports.push(row);
        } else {
          isOk = false;
        }

      });

      if (!isOk || rowsImports.length === 0) {
        this.errorMechanic = 1;
        this.visibleTxt = true;
        this.toastHandlerService.showToast(
          'error',
          'La importación terminó con errores, puede exportarlos si lo desea'
        );
        return;
      }

      await this.processImportMechanics(rowsImports);
    });
  }

  async processImportMechanics(rowsImports: Array<MechanicImportModel>) {
    try {
      const response = await firstValueFrom(this.mechanicService.importMechanics(rowsImports));
      this.loadPreInvoicingModel = response;
      this.mechanicAlerts = response?.alerts ?? [];
      this.errorMechanic = response?.preInvoicingStateId;

      if (this.errorMechanic === 1) {
        this.visibleTxt = true;
        this.toastHandlerService.showToast(
          'error',
          'La importación terminó con errores, puede exportarlos si lo desea.',
          'ERROR'
        );
      } else if (this.mechanicAlerts.length > 0) {
        this.visibleTxt = true;
        this.toastHandlerService.showToast(
          'error',
          'La importación terminó con alertas, puede exportarlas si lo desea'
        );
      } else {
        this.close();
        this.visibleTxt = false;
        this.mechanicImport = true;
        this.toastHandlerService.showToast(
          'success',
          'La importación terminó exitosamente.'
        );
      }
      this.clearInputFile();
    } catch (error) {
      this.nameFile = 'Ningún archivo seleccionado.';
      console.error('Error al importar Mecánicos.', error);
    }
  }
}
